import React from 'react';
import { Modal } from 'react-bootstrap';

const SubscriptionSuccessModal = ({ show, planName, countdown }) => {
    return (
        <Modal show={show} centered backdrop="static" keyboard={false}>
            <Modal.Body className="text-center p-5">
                <div className="mb-4 text-success">
                    <i className="ri-checkbox-circle-fill display-3"></i>
                </div>
                <h3 className="fw-bold">Congratulations!</h3>
                <p className="fs-5 text-muted">You have successfully subscribed to the <strong>{planName}</strong> plan.</p>
                <p className="mt-3">You can now enjoy all the features of your new plan. You will be redirected to the dashboard in...</p>
                <h2 className="display-4 fw-bolder my-3">{countdown}</h2>
            </Modal.Body>
        </Modal>
    );
};

export default SubscriptionSuccessModal;